import {IModalController, MK_MODAL_FLAG, MK_MODAL_FOOTER_CONFIG, MK_MODAL_HEADER_CONFIG} from "./IModalController";
import {ControllerEventBus} from "../event-buses/controller.event-bus";
import {AbstractController} from "./AbstractController";
import {signal} from "@angular/core";

export abstract class AbstractModalController extends AbstractController implements IModalController {

  protected constructor(controllerEventBus?: ControllerEventBus) {
    super(controllerEventBus);

    this.addModel(MK_MODAL_FLAG, {
      close$: signal(false),
      closeWithResult$: signal([false, {}] as [boolean, any]),
      result$: signal(null),
    });
  }

  handleInit(eventData: any): void {
    const model = this.getModel(MK_MODAL_FLAG);
    model.close$.set(false);
    model.closeWithResult$.set([false, {}]);
  }

  protected disableAllFooterActions() {
    const model = this.getModel(MK_MODAL_FOOTER_CONFIG);

    model.actions$().forEach((action) => {
      action.disabled = true;
    });
  }

  protected enableAllFooterActions() {
    const model = this.getModel(MK_MODAL_FOOTER_CONFIG);

    model.actions$().forEach((action) => {
      action.disabled = false;
    });
  }

  protected disableFooterAction(actionName: string) {
    const model = this.getModel(MK_MODAL_FOOTER_CONFIG);

    model.actions$().forEach((action) => {
      if(action.name === actionName) {
        action.disabled = true;
      }
    });
  }

  protected enableFooterAction(actionName: string) {
    const model = this.getModel(MK_MODAL_FOOTER_CONFIG);

    model.actions$().forEach((action) => {
      if(action.name === actionName) {
        action.disabled = false;
      }
    });
  }

  protected showFooterAction(actionName: string) {
    const model = this.getModel(MK_MODAL_FOOTER_CONFIG);

    model.actions$().forEach((action) => {
      if(action.name === actionName) {
        action.hidden = false;
      }
    });
  }

  protected hideFooterAction(actionName: string) {
    const model = this.getModel(MK_MODAL_FOOTER_CONFIG);

    model.actions$().forEach((action) => {
      if(action.name === actionName) {
        action.hidden = true;
      }
    });
  }

  protected setModalTitle(title: string): void {
    const model = this.getModel(MK_MODAL_HEADER_CONFIG);
    model.title$.set(title);
  }

  protected closeModal() {
    this.getModel(MK_MODAL_FLAG).close$.set(true);
  }

  protected closeModalWithResult(result: any) {
    this.getModel(MK_MODAL_FLAG).closeWithResult$.set([true, result]);
  }
}
